import React, { useState, useEffect, useContext } from "react";
import Modal from "@mui/joy/Modal";
import ModalClose from "@mui/joy/ModalClose";
import Typography from "@mui/joy/Typography";
import Sheet from "@mui/joy/Sheet";
import AuthContext from "../../contexts/authContext";
import { Box, Divider, Input } from "@mui/joy";

export default function ViewUser({
  openViewUser,
  setOpenViewUser,
  setUserId,
  userId,
}) {
  const [viewData, setViewData] = useState([]);
  const [filteredPayments, setFilteredPayments] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const { userData } = useContext(AuthContext);

  useEffect(() => {
    if (userId) {
      const viewuser = userData?.users?.find((item) => item._id === userId);
      setViewData(viewuser);
    }
  }, [userId, userData]);

  useEffect(() => {
    if (viewData?._id && startDate && endDate) {
      const start = new Date(startDate); // 00:00 of start
      const end = new Date(endDate);
      end.setDate(end.getDate() + 1); // 00:00 of *next* day

      const filtered = userData?.payments?.filter((p) => {
        const created = new Date(p.createdAt);
        return (
          p.agentId._id === viewData._id &&
          created >= start && // inclusive
          created < end // still includes original end-day
        );
      });

      setFilteredPayments(filtered);
    } else {
      setFilteredPayments([]);
    }
  }, [startDate, endDate, viewData, userData]);

  const handleCloseViewUser = () => {
    setOpenViewUser(false);
    setUserId("");
    setViewData([]);
    setStartDate("");
    setEndDate("");
    setFilteredPayments([]);
  };

  return (
    <React.Fragment>
      <Modal
        aria-labelledby="modal-title"
        aria-describedby="modal-desc"
        open={openViewUser}
        onClose={handleCloseViewUser}
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <Sheet
          variant="outlined"
          sx={{
            maxWidth: 600,
            width: "100%",
            bgcolor: "#FEDDDD",
            p: 3,
            borderRadius: "md",
            boxShadow: "lg",
            m: 2,
          }}
        >
          <ModalClose
            variant="plain"
            sx={{
              m: 1,
              "& svg": { color: "#800001" },
              "&:hover": {
                backgroundColor: "#800001",
                "& svg": { color: "#fff" },
              },
            }}
          />

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Typography level="h4" sx={{ fontWeight: "bold" }}>
              {viewData?.name} -
            </Typography>

            {filteredPayments.length > 0 && (
              <Typography
                // level="body-sm"
                sx={{ fontWeight: "bold", color: "#800001" }}
              >
                {" "}
                ₹
                {filteredPayments.reduce(
                  (acc, curr) => acc + curr.amountPaid,
                  0
                )}{" "}
              </Typography>
            )}
          </Box>

          <Typography sx={{ mb: 2, color: "#555" }}>
            {viewData?.mobile}
          </Typography>

          <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
            <Input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              fullWidth
              variant="outlined"
            />
            <Input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              fullWidth
              variant="outlined"
            />
          </Box>

          <Divider sx={{ mb: 2 }} />

          {filteredPayments.length > 0 ? (
            <Box sx={{ maxHeight: 300, overflowY: "auto" }}>
              {filteredPayments.map((payment, idx) => (
                <Box
                  key={payment._id || idx}
                  sx={{
                    mb: 1,
                    p: 1,
                    bgcolor: "#fff",
                    borderRadius: "5px",
                  }}
                >
                  <Box
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Typography level="body-sm" sx={{ fontWeight: "bold" }}>
                      {payment.customerId?.name} -{" "}
                      {
                        userData?.schemes?.find(
                          (item) => item._id === payment.schemeId?.schemeId
                        )?.schemeName
                      }
                    </Typography>
                    <Typography level="body-xs" sx={{ color: "#800001" }}>
                      {payment.amountPaid}
                    </Typography>
                  </Box>

                  <Box
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Typography level="body-sm" sx={{ fontWeight: "bold" }}>
                      Remarks: {payment.remarks || "—"}
                    </Typography>
                    <Typography level="body-xs" color="neutral">
                      {payment.createdAt.split("T")[0]}
                    </Typography>
                  </Box>

                  {/* <Typography level="body-xs" color="neutral">
                    Receipt: {payment.receiptReference || "N/A"}
                  </Typography> */}
                </Box>
              ))}
            </Box>
          ) : (
            <Typography level="body-sm" color="neutral" sx={{ mt: 1 }}>
              No payments in this range.
            </Typography>
          )}
        </Sheet>
      </Modal>
    </React.Fragment>
  );
}
